import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import DeprecatedLayout from '@/components/_deprecated/template/Layout';
import AppShell from '@/components/app-shell/AppShell';
import ShellSidebar from '@/components/app-shell/ShellSidebar';
import ShellContent from '@/components/app-shell/ShellContent';
import ShellDock from '@/components/app-shell/ShellDock';
import ShellHeader from '@/components/app-shell/ShellHeader';
import ForceAuth from '@/components/auth/ForceAuth';
import UiVersionSwitcher from '@/components/ui/custom/UiVersionSwitcher';
import { AppShellProvider } from '@/data/context/AppShellContext';
import LoadingView from '@/pages/courses/LoadingView';

export default function AppShellFrame() {
  return (
    <UiVersionSwitcher scope="appShell">
      <UiVersionSwitcher.Legacy>
        <Suspense
          fallback={
            <DeprecatedLayout privated={false}>
              <LoadingView />
            </DeprecatedLayout>
          }
        >
          <Outlet />
        </Suspense>
      </UiVersionSwitcher.Legacy>
      <UiVersionSwitcher.Modern>
        <ForceAuth>
          <AppShellProvider>
            <AppShell>
              <AppShell.Body>
                <ShellContent>
                  <ShellHeader />
                  <AppShell.Page>
                    <Outlet />
                  </AppShell.Page>
                </ShellContent>
                <AppShell.Dock>
                  <ShellDock />
                </AppShell.Dock>
              </AppShell.Body>
              <AppShell.Sidebar>
                <ShellSidebar />
              </AppShell.Sidebar>
            </AppShell>
          </AppShellProvider>
        </ForceAuth>
      </UiVersionSwitcher.Modern>
    </UiVersionSwitcher>
  );
}
